
document.addEventListener('DOMContentLoaded', () => {
  const money = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency', currency: window.Shopify?.currency?.active || 'EUR'}).format(cents/100); }
    catch(e){ return (cents/100).toFixed(2) + ' €'; }
  };
  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerItems = drawer?.querySelector('[data-cart-items]');
  const drawerTotal = drawer?.querySelector('[data-cart-total]');
  const countEls = document.querySelectorAll('[data-cart-count]');
  const openDrawer = () => drawer?.classList.add('is-open');
  const closeDrawer = () => drawer?.classList.remove('is-open');
  drawer?.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', closeDrawer));
  document.querySelectorAll('[data-cart-open]').forEach(el => el.addEventListener('click', async (e) => { e.preventDefault(); await refreshCart(); openDrawer(); }));

  async function refreshCart(){
    if(!drawer) return;
    const cart = await fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(r=>r.json());
    countEls.forEach(el => el.textContent = cart.item_count);
    if(drawerTotal) drawerTotal.textContent = money(cart.total_price);
    if(drawerItems){
      if(!cart.items.length){ drawerItems.innerHTML = '<p class="muted">Dein Warenkorb ist leer.</p>'; }
      else drawerItems.innerHTML = cart.items.map(item => `
        <div class="cart-drawer__item">
          ${item.image ? `<img src="${item.image}" alt="">` : ''}
          <div><strong>${item.product_title}</strong><small class="muted">${item.variant_title || ''} · ${item.quantity}×</small></div>
          <strong>${money(item.final_line_price)}</strong>
        </div>`).join('');
    }
  }

  document.querySelectorAll('form[data-ajax-add]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      if(btn){ btn.disabled = true; btn.dataset.oldText = btn.textContent; btn.textContent = 'Wird hinzugefügt…'; }
      try{
        const fd = new FormData(form);
        await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd}).then(r=>{if(!r.ok) throw new Error('add failed'); return r.json();});
        await refreshCart(); openDrawer();
      }catch(err){ form.submit(); }
      finally{ if(btn){ btn.disabled = false; btn.textContent = btn.dataset.oldText || 'In den Warenkorb'; } }
    });
  });

  const sticky = document.querySelector('[data-sticky-atc]');
  const mainForm = document.querySelector('[data-main-product-form]');
  if(sticky && mainForm){
    const io = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), {threshold:.15});
    io.observe(mainForm);
  }
  document.querySelectorAll('[data-sticky-submit]').forEach(btn => btn.addEventListener('click', () => mainForm?.requestSubmit()));

  document.querySelectorAll('[data-product-thumb]').forEach(btn => btn.addEventListener('click', () => {
    const src = btn.dataset.src;
    const main = document.querySelector('[data-product-main-image]');
    if(src && main) main.src = src;
  }));
});

window.addEventListener('scroll',()=>document.body.classList.toggle('is-scrolled',window.scrollY>30),{passive:true});


(function(){
  const reveal = () => {
    const els = document.querySelectorAll('.reveal-on-scroll:not(.is-revealed)');
    if(!('IntersectionObserver' in window)){ els.forEach(el=>el.classList.add('is-revealed')); return; }
    const io = new IntersectionObserver(entries => entries.forEach(entry => {
      if(entry.isIntersecting){ entry.target.classList.add('is-revealed'); io.unobserve(entry.target); }
    }), {threshold:.12, rootMargin:'0px 0px -40px'});
    els.forEach(el=>io.observe(el));
  };

  const sliders = () => document.querySelectorAll('[data-lifestyle-slider]').forEach(slider => {
    if(slider.dataset.ready) return; slider.dataset.ready='true';
    const track=slider.querySelector('[data-lifestyle-track]');
    const slides=[...slider.querySelectorAll('[data-lifestyle-slide]')];
    const dots=[...slider.querySelectorAll('[data-lifestyle-dots] button')];
    const prev=slider.querySelector('[data-lifestyle-prev]'); const next=slider.querySelector('[data-lifestyle-next]');
    if(!track || !slides.length) return;
    let i=0, timer, startX=null;
    const show=(n)=>{ i=(n+slides.length)%slides.length; track.style.transform=`translateX(-${i*100}%)`; dots.forEach((d,x)=>d.classList.toggle('is-active',x===i)); slides.forEach((s,x)=>s.classList.toggle('is-active',x===i)); };
    const autoplay=()=>{ clearInterval(timer); timer=setInterval(()=>show(i+1),6500); };
    prev?.addEventListener('click',()=>{show(i-1);autoplay()}); next?.addEventListener('click',()=>{show(i+1);autoplay()}); dots.forEach((d,x)=>d.addEventListener('click',()=>{show(x);autoplay()}));
    slider.addEventListener('mouseenter',()=>clearInterval(timer)); slider.addEventListener('mouseleave',autoplay);
    slider.addEventListener('touchstart',e=>startX=e.touches[0].clientX,{passive:true}); slider.addEventListener('touchend',e=>{if(startX===null)return; const dx=e.changedTouches[0].clientX-startX;if(Math.abs(dx)>45)show(i+(dx<0?1:-1));startX=null;autoplay()},{passive:true});
    show(0); autoplay();
  });
  document.addEventListener('DOMContentLoaded',()=>{reveal();sliders();});
  document.addEventListener('shopify:section:load',()=>{reveal();sliders();});
})();
